/* eslint-disable prefer-template */
import {
  IntervalCheckpoint1,
  IntervalCheckpoint2,
  IntervalCheckpoint3,
  Memory,
  ReadyToStudyCap } from 'es6/models/memory';

export default class MemoryBankNode extends Memory {
  constructor(attrs = {}) {
    super(attrs);

    // Additional attributes that are not apart of main memory.
    _.defaults(this, {
      id: null,
      name: null,
      inSession: false,
    });
  }

  isNew() {
    return this.reviewInterval === null;
  }

  isAtCheckpoint1() {
    return this.reviewInterval >= IntervalCheckpoint1;
  }

  isAtCheckpoint2() {
    return this.reviewInterval >= IntervalCheckpoint2;
  }

  isAtCheckpoint3() {
    return this.reviewInterval >= IntervalCheckpoint3;
  }

  /**
   * On the memory bank, the concept of ready really means that
   * the retention is below the retention cap. Do not take
   * short term memory into consideration.
   *
   * @override
   * @returns {Boolean}
   */
  isReady() {
    return this.currentRetention < ReadyToStudyCap;
  }

  /**
   * Get a string that can be used to see if two nodes
   * are in the same position.
   *
   * @return {String}
   */
  getPositionKey() {
    return this.x + ',' + this.y;
  }

  /**
   * Helper method to convert from an item package.
   *
   * overrideAttrs: Attributes to override for creating memory bank node.
   */
  static createFromItemPackage(itemPackage, memory, inSession = false) {
    const attrs = _.extend({}, memory, {
      id: 'itempackage-' + itemPackage.getId(),
      name: itemPackage.getText(),
      inSession,
    });

    return new MemoryBankNode(attrs);
  }
}
